import TxtFooter from '../../components/txtFooter/index.jsx';
import Character from '../../components/character/index.jsx';
import Background from '../../components/background/index.jsx';
import CogIcon from '../../components/cogIcon/index.jsx';
import Options from '../../components/options/index.jsx';
import ExitIcon from '../../components/exitIcon/index.jsx';
import { useState, useEffect, useCallback } from 'react';
import PrologueStory from '../../storyLine';
let storyPoint = 0;

export default (props) => {
    const [backgroundImg, setBackgroundImg] = useState();
    const [characterImg, setCharacterImg] = useState();
    const [speakerName, setSpeakerName] = useState();
    const [speakerTxt, setSpeakerTxt] = useState();
    const [choicesBtns, setChoices] = useState();
    const [StoryLines, setStoryLines] = useState(PrologueStory);
    const [firstBranchStoryLine, setFirstBranchStoryLine] = useState();
    const [secondBranchStoryLine, setSecondBranchStoryLine] = useState();
    const [appendNewStoryParts, setAppendNewStoryParts] = useState();
    const [showOptions, setShowOptions] = useState(false);
    const { exitGame } = props;

    const useNextStep = (event) => {
        window.soundSFX.pause();
        window.ttsDialogue.pause();
        if(event !== undefined && clickOnIcons(event.srcElement, 'optionBtn')) {
            window.removeEventListener('click', useNextStep);
            setShowOptions(true)
            return;
        }

        if(event !== undefined && clickOnIcons(event.srcElement, 'exitBtn')) {
            exitGame('HomeScreen')
        }
        storyPoint++;
        updateScreen(StoryLines[storyPoint]);
    }

    const clickOnIcons = (srcElement, elementId) => {
        if(srcElement.tagName === 'path') {
            const parentId = '#'+elementId
            if(srcElement.closest(parentId)) {
                return true;
            }
        }

        if(srcElement.tagName === 'svg') {
            if(srcElement.id === elementId) {
                return true;
            }
        }
    }

    const forceUpdate = useCallback((soundSFX) => {
        updateScreen(StoryLines[storyPoint], 'forceUpdate');
    }, []);

    const updateScreen = (storyLine, call) => {
        const elements = ['speakerTxt', 'speakerName', 'characterImg', 'characterImg', 'backgroundImg', 'choicesBtns', 'soundFx', 'choiceDialog', 'dialogFx'];

        elements.forEach((element) => {
            switch (element) {
                case 'speakerTxt':
                    if(storyLine?.speakerTxt) {
                        setSpeakerTxt(storyLine.speakerTxt)
                    }

                    if(window.rs && storyLine?.speakerTxtRS) {
                        setSpeakerTxt(storyLine.speakerTxtRS)
                    }
                    break;
                case 'speakerName':
                    if(storyLine?.speakerName) {
                        setSpeakerName(storyLine.speakerName)
                    }

                    if(window.rs && storyLine?.speakerNameRS) {
                        setSpeakerName(storyLine.speakerNameRS)
                    }

                    if(storyLine?.speakerName === 'unset') {
                        setSpeakerName(null)
                    }
                    break;
                case 'characterImg':
                    if(storyLine?.characterImg) {
                        setCharacterImg(storyLine.characterImg)
                    }

                    if(storyLine?.characterImg === 'unset') {
                        setCharacterImg(null)
                    }
                    break;
                case 'backgroundImg':
                    if(storyLine?.backgroundImg) {
                        setBackgroundImg(storyLine.backgroundImg)
                    }
                    break;
                case 'soundFx':
                    if(storyLine?.soundFx && window.soundSFX.playingEnabled) {
                        window.soundSFX.loop = false;
                        window.soundSFX.src = storyLine.soundFx
                        if(storyLine.soundLoop) {
                            window.soundSFX.loop = true;
                        }
                        window.soundSFX.play();
                    }
                    break;
                case 'choicesBtns':
                    if(storyLine?.choicesBtns && storyLine.choicesBtns !== undefined && storyLine.appendNextStoryParts !== undefined) {
                        window.removeEventListener('click', useNextStep);
                        setChoices(storyLine.choicesBtns)
                        setFirstBranchStoryLine(storyLine.appendNextStoryParts[0])
                        setSecondBranchStoryLine(storyLine.appendNextStoryParts[1])
                    }

                    if(window.rs && storyLine?.choicesBtns) {
                        setChoices(storyLine.choicesBtnsRS)
                    }

                    if(storyLine?.choicesBtns === 'unset') {
                        setChoices(null)
                    }
                    break;
                    case 'dialogFx':
                        if(storyLine?.dialogFx && window.ttsDialogue.playingEnabled && !window.rs) {
                            window.ttsDialogue.src = storyLine.dialogFx
                            window.ttsDialogue.play();
                        }
                        break;
                default:
                    break;
            }
        })
    }

    useEffect(() => {
        setTimeout(() => {
            window.addEventListener('click', useNextStep);
        }, 1000);
        updateScreen(StoryLines[storyPoint], 'useEffect');
        window.backgroundSFX.play();
        window.backgroundSFX.playingEnabled = true;
        
        return () => {
            window.removeEventListener('click', useNextStep);
            storyPoint = 0;
            window.ttsDialogue.pause();
            window.soundSFX.pause();
            window.backgroundSFX.pause();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(appendNewStoryParts) {
            let constructedStoryLines = StoryLines;

            appendNewStoryParts.map((nextSegment) => {
                constructedStoryLines = constructedStoryLines.concat(nextSegment);
            })

            setStoryLines(constructedStoryLines);
            setAppendNewStoryParts(null);
        }

        if(appendNewStoryParts === null) {
            useNextStep();
            window.addEventListener('click', useNextStep);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appendNewStoryParts])

    useEffect(() => {
        if(showOptions === false) {
            setTimeout(() => {
                window.addEventListener('click', useNextStep);
            }, 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showOptions])

    return (
        <Background backgroundImg={ backgroundImg }>
            <ExitIcon />
            { showOptions && <Options closeFn={setShowOptions} updateParent={forceUpdate} /> }
            <CogIcon />
            <>
                {
                    characterImg && characterImg?.split('&&').map((img, index) => {
                        return <Character key={ index } characterImg={ img } />
                    })
                }
            </>
            <TxtFooter 
                speakerName = { speakerName }
                speakerTxt = { speakerTxt }
                choicesBtns = { choicesBtns }
                firstBtnAction = {() => {
                    setAppendNewStoryParts(firstBranchStoryLine)
                }}
                secondBtnAction = {() => {
                    setAppendNewStoryParts(secondBranchStoryLine)
                }}
            />
        </Background>
    );
}